import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router";
import "../assets/sass/dashboard.scss";
import Sidebar from "../components/Sidebar";
import Collaboratives from "../views/Collaboratives";
import Feedback from "../views/Feedback";
import ForgetPassword from "../views/ForgetPassword";
import FutureMessages from "../views/FutureMessages";
import Login from "../views/Login";
import ManageAccount from "../views/ManageAccount";
import Memoirs from "../views/Memoirs";
import ProfileDetail from "../views/ProfileDetail";
import ProfileDetailV1 from "../views/ProfileDetailV1";
import QrCode from "../views/QrCode";
import QrCodeOrder from "../views/QrCodeOrder";
import Register from "../views/Register";
import SharedWithMe from "../views/SharedWithMe";
import SignUp from "../views/SignUp";
import Timeline from "../views/Timeline";
import CustomAlert from "../components/Modals/CustomAlert";

class DashboardLayout extends Component {
  state = {};
  componentDidMount() {
    document.body.classList.remove("dark");
    document.body.classList.remove("light");
    document.body.classList.add(this.props.themeType);
    if (this.props.authUser == null) {
      this.props.history.push("/dashboard/register");
    }
  }
  render() {
    return (
      <div
        className={`dashboard ${this.props.themeType} d-flex align-items-start p-4`}
      >
        <CustomAlert />
        <Sidebar {...this.props} />
        <div className="pl-4 w-100">
          {/* {!(
						this.props.history.location.pathname ==
							'/dashboard/timeline/profile' ||
						this.props.history.location.pathname ==
							'/dashboard/timeline/profileV1'
					) && <Topbar {...this.props} />} */}
          <Switch>
            {console.log("first", this.props.authUser != null)}
            {this.props.authUser != null ? (
              <>
                <Route path="/dashboard/memoirs" exact>
                  <Memoirs {...this.props} />
                </Route>

                <Route path="/dashboard/login" exact>
                  <Login {...this.props} />
                </Route>
                <Route path="/dashboard/forget-password" exact>
                  <ForgetPassword {...this.props} />
                </Route>
                <Route path="/dashboard/manage-account" exact>
                  <ManageAccount {...this.props} />
                </Route>
                <Route path="/dashboard/:id/timeline" exact>
                  <Timeline {...this.props} />
                </Route>
                <Route path="/dashboard/timeline/profileV1" exact>
                  <ProfileDetailV1 {...this.props} />
                </Route>
                <Route path="/dashboard/timeline/profile" exact>
                  <ProfileDetail {...this.props} />
                </Route>
                <Route path="/dashboard/collaboratives" exact>
                  <Collaboratives {...this.props} />
                </Route>
                <Route path="/dashboard/collaboratives/shared-with-me" exact>
                  <SharedWithMe {...this.props} />
                </Route>
                <Route path="/dashboard/future-messages" exact>
                  <FutureMessages {...this.props} />
                </Route>
                <Route path="/dashboard/feedback" exact>
                  <Feedback {...this.props} />
                </Route>
                <Route path="/dashboard/qrcode" exact>
                  <QrCode {...this.props} />
                </Route>
                <Route path="/dashboard/qrcode/order" exact>
                  <QrCodeOrder {...this.props} />
                </Route>
              </>
            ) : (
              <>
                <Route path="/dashboard/signup" exact>
                  <SignUp {...this.props} />
                </Route>
                <Route path="/dashboard/register" exact>
                  <Register {...this.props} />
                </Route>
              </>
            )}
            {this.props.authUser == null ? (
              <Redirect from="*" to="/dashboard/register" />
            ) : (
              <Redirect from="*" to="/dashboard/manage-account" />
            )}
          </Switch>
        </div>

        {/* {this.props.children} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    themeType: state.theme.themeType,
    auth: state.auth,
    authUser: state.authUser,
  };
};

export default connect(mapStateToProps)(DashboardLayout);
